/* * @Author: 孙福聪 * @Date: 2019-02-15 10:45:57 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-03-27 17:14:27 */
<template lang="pug">
div.task-main
  component(v-for='(item,index) in assemblyList',
    v-disabled="seeState"
    :key='index',
    v-if='item',
    :eachIndex="index",
    :is='item.scene||item.name',
    :assemblyName="assemblyName",
    :selectDepartment1="selectDepartment",
    :info="item.info",
    :data='item.data'
    :name='item.name'
    :ha-id="haId"
    :task-id="item.info ? item.info.id : ''"
    :taId="taId"
    :cdId="cdId"
    :enableAI="enableAI"
    :fun_office1='item.fun_office'
    @delModel='delModel',
    :ref='`taskIndex${index}`',
    :draggable="dragState",
    @startDrag='dragState=true',
    @dragend.native='endDrag',
    @upData='son_upData',
    @downData='son_downData',
    @info:data='infoChange'
    @changeData='childChangeData'
    @updateTableData="updateTableData"
    @updateUploadData="updateUploadData"
    ).model
  div.drag(@drop="fun_drop",@dragover="allowDrop")
    p  把场景拖入此区域吧!
</template>
<script>
import mybus from "@/utils/main";
import MultipleA from "@/components/case/multiple";
import MultipleB from "@/components/case/multiple";
import Fillblank from "@/components/case/fillblank";
import EasyQuestion from "@/components/case/easyQuestion";
import Material from "@/components/case/material";
import CaseAxis from "@/components/case/caseAxis";
import CaseDialogue from "@/components/case/caseDialogue";
import CaseAskAndAnswer from "@/components/case/caseAskAndAnswer";
import CaseInfoBase from "@/components/case/caseInfoBase";
import CaseDepartment from "@/components/case/caseDepartment";
import CaseUpload from "@/components/case/caseUpload";
import CaseTitle from "@/components/case/caseTitle";
import smallCaseTitle from "@/components/case/smallCaseTitle";
import tableQuestion from "@/components/case/tableQuestion";
import CaseGuide from "@/components/case/caseGuide";
import CasePhotoText from "@/components/case/casePhotoText";
import CaseSingleText from "@/components/case/caseSingleText";
import CaseTitleText from "@/components/case/caseTitleText";
import CaseVideo from "@/components/case/caseVideo";
import Divider from "@/components/case/divider";
// 部门
import HALLBACKGROUND from "@/components/department/HallBackGround";
import LEADERSHIPOFFICE from "@/components/department/LeadershipOffice";
import MYOFFICE from "@/components/department/myOffice";
import POLLINGCENTER from "@/components/department/researchCenter";
import METTING from "@/components/department/scene";
import SURVEY from "@/components/department/survey";
import Unit from "@/components/department/unit";
import Single from "./single";

export default {
  props: ["assemblyName", "data", "selectDepartment", "enableAI", "taId"],
  inject: ["seeState"],

  components: {
    Single,
    MultipleA,
    MultipleB,
    Fillblank,
    EasyQuestion,
    Material,
    CaseAxis,
    CaseDialogue,
    CaseAskAndAnswer,
    CaseInfoBase,
    CaseDepartment,
    CaseUpload,
    CaseGuide,
    CasePhotoText,
    CaseSingleText,
    CaseTitleText,
    CaseVideo,
    CaseTitle,
    smallCaseTitle,
    Divider,
    LEADERSHIPOFFICE,
    MYOFFICE,
    POLLINGCENTER,
    tableQuestion,
    SURVEY,
    METTING,
    UnitA: Unit, // 5
    UnitB: Unit, // 6
    UnitC: Unit, // 7
    UnitD: Unit, // 8
    UnitE: Unit, // 9
    UnitF: Unit, // 10
    UnitG: Unit, // 11
    UnitH: Unit, // 12
    UnitI: Unit, // 13
    UnitJ: Unit, // 14
    UnitK: Unit, // 15
    UnitL: Unit, // 16
    UnitM: Unit, // 17
    UnitN: Unit, // 18
    UnitO: Unit, // 19
    UnitP: Unit, // 20
    UnitQ: Unit, // 21
    HALLBACKGROUND
  },
  data() {
    return {
      dragState: false, // 控件是否可以被拖动
      assemblyList: [], // 拖进来的组件
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      stepIndex: 0,
      haId: "",
      taskId: "",
      cdId: ""
    };
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    taskList() {
      return this.$store.state.task.task;
    },
    getAssemblyList() {
      console.log(
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]],
        "caseDatacaseData"
      );
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].task[this.$parent.stepIndex - 1].SceneList;
    },
    taskHome() {
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].taskHome;
    }
  },
  watch: {
    getAssemblyList: {
      handler() {
        if (this.getAssemblyList) {
          JSON.parse(JSON.stringify(this.getAssemblyList)); // this.$emit('e1', newVal)
        }
      },
      deep: true
    }
  },
  created() {
    console.log("瓜瓜", this.enableAI);
    // this.assemblyList = JSON.parse(JSON.stringify(this.getAssemblyList));
    console.log(this.getAssemblyList, "this.getAssemblyList");
    this.getAssemblyList.forEach((res) => {
      console.log(res, "调研res");
      this.haId =
        this.$store.state.Case.caseData[
          this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
        ].HallId;
      this.taskId = res.id;
      const data = {
        name: "",
        fun_office: res.functionName ? res.functionName : res.departmentName,
        info: {
          id: res.id,
          cdId: res.cdId
        }
      };
      data.name = res.scene;
      // obj =
      data.info.departmentName = res.departmentName;
      data.info.id = res.id;
      console.log(data, "dataaaa");
      this.assemblyList.push(data);
    });
    this.$emit("nextStep", this.data);
    mybus.$on("editDepartment", (dataP) => {
      this.assemblyList = [];
      dataP.forEach((res) => {
        const data = {
          name: "",
          fun_office: res.functionName ? res.functionName : res.departmentName,
          info: {
            id: res.id,
            cdId: res.cdId
          }
        };
        data.name = res.scene;
        // obj =
        data.info.departmentName = res.departmentName;
        data.info.id = res.id;
        this.assemblyList.push(data);
      });
    });
    this.stepIndex = this.$parent.stepIndex - 1;
    //
    // console.log(
    //   this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
    //     .task[this.$parent.stepIndex - 1].SceneList
    // );
  },
  methods: {
    updateTableData(val) {
      this.$emit("handUpdate", val);
    },
    updateUploadData(val) {
      this.$emit("handUploadData", val);
    },
    infoChange(val, index) {
      // val => { return item.info = val; };
      console.log(this.assemblyList, "[index].info");
      console.log(val, "val\n");
      this.assemblyList[index].info = { ...this.assemblyList[index].info, ...val };
    },
    /** 子组件更改父组件 */
    childChangeData(data) {
      const {
        type,
        data: { name: childData, DATA: cData },
        index: eachIndex
      } = data;
      /** 以后如果其他组件有需要可以增加，现在只是unit组件 */
      if (type === "unit") {
        const oldData = this.assemblyList[eachIndex];
        const indexData = this.$refs[`taskIndex${eachIndex}`][0].assemblyList;
        console.log(oldData, indexData, childData, cData, "datra");
        this.$set(this.assemblyList, eachIndex, { ...oldData, name: childData, data: indexData });
        // this.assemblyList[eachIndex] = { ...oldData, name: childData };
        // this.assemblyList[eachIndex].data = indexData;
        /** 渲染后，滚动条没了，但是切换顺序又显示了。 */
        /** 模态框的问题，因为每个组件(页面)都会有模态框。在切换到下一个时，需要把modal关掉。否则modal的遮罩会锁页，不可滚动。 */
        // if()
      }
    },
    son_downData(index, e) {
      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个场景啦~");
      }

      const data1 = e; // 被移动的场景
      const data2 = this.$refs[`taskIndex${index + 1}`][0].assemblyList;

      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index]
      ];
      this.assemblyList[index].data = data2;
      this.assemblyList[index + 1].data = data1;
      console.log(this.assemblyList);
      // 场景组建传递上来的和下一个场景交换函数

      this.$forceUpdate();
    },
    son_upData(index, e) {
      if (index === 0) {
        return this.$Message.error("已经是第一个场景啦~");
      }
      const data1 = this.$refs[`taskIndex${index - 1}`][0].assemblyList;
      const data2 = e; // 被移动的场景

      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index]
      ];
      this.assemblyList[index].data = data1;
      this.assemblyList[index - 1].data = data2;
      // 场景组建传递上来的和上一个场景交换函数
      console.log(this.assemblyList);
      this.$forceUpdate();
    },
    fun_drop() {
      console.log(this.assemblyName, "assemblyName");
      if (
        this.assemblyName !== "" &&
        this.assemblyName !== "Single" &&
        this.assemblyName !== "MultipleA" &&
        this.assemblyName !== "MultipleB" &&
        this.assemblyName !== "Fillblank" &&
        this.assemblyName !== "EasyQuestion" &&
        this.assemblyName !== "Material" &&
        this.assemblyName !== "CaseAxis" &&
        this.assemblyName !== "CaseDialogue" &&
        this.assemblyName !== "CaseGuide" &&
        this.assemblyName !== "CasePhotoText" &&
        this.assemblyName !== "CaseSingleText" &&
        this.assemblyName !== "CaseTitleText" &&
        this.assemblyName !== "CaseVideo" &&
        this.assemblyName !== "MultipeChoice" &&
        this.assemblyName !== "CaseTitle" &&
        this.assemblyName !== "Divider" &&
        this.assemblyName !== "CaseAskAndAnswer"
      ) {
        let lock = true;
        this.taskList.forEach((item) => {
          if (item.departmentName) {
            if (item.departmentName === this.selectDepartment) {
              lock = false;
            }
          }
        });
        if (!lock) {
          return this.$Message.error("不可以拖入相同的部门");
        }
        this.assemblyList.push({ name: this.assemblyName });
        this.$store.commit("addDepartmentData", this.selectDepartment);
        this.taskHome.forEach((item) => {
          console.log(item, this.selectDepartment, "1");
          if (item.departmentName === this.selectDepartment) {
            console.log("111");
            const obj = {};
            obj.departmentName = item.departmentName;
            obj.cdId = item.id || item.chId;
            this.cdId = obj.cdId;
            this.assemblyList[this.assemblyList.length - 1].info = obj;
          }
        });
        console.log(this.assemblyList);
      }
    },
    allowDrop(e) {
      e.preventDefault();
    },
    delModel(value, deptIndex) {
      // 删除模块
      let idx = -1;
      console.log(value, "这是个啥啊");
      this.assemblyList.forEach((item, index) => {
        if (value === item.scene || value === item.name) {
          idx = index;
        }
      });
      // deptIndex 新参数。因为增加了场景切换功能，所以很有可能出现重复的情况，所以不能单纯通过name判断
      // 这里如果传了deptIndex，说明是部门过来的，直接用deptIndex
      if (deptIndex) {
        idx = deptIndex;
      }
      console.log(idx, "对应索引", deptIndex);

      // delete this.assemblyList[idx];
      if (this.assemblyList[idx].info && this.assemblyList[idx].info.id) {
        this.$emit("delModel", this.assemblyList[idx].info.id);
      }
      this.assemblyList.splice(idx, 1);
      this.$store.commit("deleteDepartmentData", idx);
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="stylus" scoped>
.task-main
  padding 24px 32px 60px 32px
  height auto
  background #fff
  -webkit-box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.2)
  box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.2)
  border-radius 4px
  margin-top 16px
  min-width 854px
  max-width 1000px
.drag
  min-width 790px
  height 100px
  background #fff
  border-radius 4px
  border 1px dashed rgba(128, 128, 128, 0.5)
  margin-top 24px
  cursor alias
  p
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(128, 128, 128, 0.5)
    line-height 100px
    text-align center
</style>
